__turbopack_context__.v({
  "ctaSection": "ReviewHero-module__zPWpsa__ctaSection",
  "fixedCta": "ReviewHero-module__zPWpsa__fixedCta",
  "fullWwrapper": "ReviewHero-module__zPWpsa__fullWwrapper",
  "gauge": "ReviewHero-module__zPWpsa__gauge",
  "hidden": "ReviewHero-module__zPWpsa__hidden",
  "infoSection": "ReviewHero-module__zPWpsa__infoSection",
  "keyInfo": "ReviewHero-module__zPWpsa__keyInfo",
  "keyInfoItem": "ReviewHero-module__zPWpsa__keyInfoItem",
  "ratingSection": "ReviewHero-module__zPWpsa__ratingSection",
  "vehicleSection": "ReviewHero-module__zPWpsa__vehicleSection",
  "visable": "ReviewHero-module__zPWpsa__visable",
  "wrapper": "ReviewHero-module__zPWpsa__wrapper",
});
